<template>
  <div
    :class="DS_GRID_CLASSES.Root"
    data-cy="ds-grid"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { DS_GRID_CLASSES } from "@/src/design_system/layouts_and_containers/grid/constants/classes";
</script>
